import React from "react";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import Slider from "@material-ui/core/Slider";
import LocalStorageHelper from "../../../common/localStorageHelper";
import { environment } from "../../../data/config";
import Button from "../../base-components/Button";

const StationFilter = (props) => {
    let {
        flightFilters: currentFlightFilters,
        onFlightFilter,
        handleClose,
        allFlights,
        allStations,
        allModels,
        allGatess,
        allGatess11,
    } = props;

    console.log("stationfilter", allGatess11);

    currentFlightFilters = LocalStorageHelper.appliedFilters.get();

    const GATE_FILTER_TYPES = {
        ALL: 1,
        NONE: 2,
        ONE: 3,
    };

    const FLEET_FILTER_TYPES = {
        ALL: 1,
        NONE: 2,
        ONE: 3,
    };

    const GATE11_FILTER_TYPES = {
        ALL: 1,
        NONE: 2,
        ONE: 3,
    };

    /* #region  Slider configuration */
    let maxHour = environment.maxTimeWindow; //Slider hours

    function valuetext(value) {
        return `${value} hr`;
    }

    function fleetLabel(gateNumber) {
        return gateNumber;
    }

    //Generate gate11 label
    function gate11Label(gateNumber) {
        return "Gate " + gateNumber;
    }

    const marks = () => {
        const result = [];
        for (let i = 1; i <= maxHour; i++) {
            result.push({
                value: i,
                label: `${i} hr`,
            });
        }
        return result;
    };

    /* #endregion */

    const [flightFilters, setFlightFilters] = React.useState(currentFlightFilters);

    const error = false; // FormControl related...

    /* #region  Event handling */
    const onSetFleet = (selectionType, e) => {
        let checked = e.target.checked;
        let updatedFilter = { ...flightFilters };
        // console.info("onSetFlight updatedFilter", updatedFilter);
        // console.info("onSetFlight updatedFilter checked", checked);

        switch (selectionType) {
            case FLEET_FILTER_TYPES.ALL:
                if (checked) {
                    updatedFilter.aircraftFilters = allModels;
                    // console.info("fleet all if", updatedFilter.aircraftFilters)
                } else {
                    updatedFilter.aircraftFilters = [];
                    // console.info("fleet all else", updatedFilter.aircraftFilters)
                }
                // console.info("fleet updatedFilter", updatedFilter)
                setFlightFilters(updatedFilter);
                return;

            case FLEET_FILTER_TYPES.ONE:
                let fleetType = e.target.value;
                if (checked) {
                    // console.info("fleet one if", fleetType)
                    updatedFilter.aircraftFilters = updatedFilter.aircraftFilters.concat(fleetType);
                    // console.info("fleet one else", updatedFilter.aircraftFilters)
                } else {
                    updatedFilter.aircraftFilters = updatedFilter.aircraftFilters.filter(
                        (fleet) => fleet !== fleetType
                    );
                }
                setFlightFilters(updatedFilter);
                // console.info("  ",updatedFilter)
                return;
            default:
                return;
        }
    };

    const onSetGate11 = (selectionType, e) => {
        let checked = e.target.checked;
        let updatedFilter = { ...flightFilters };

        switch (selectionType) {
            case GATE11_FILTER_TYPES.ALL:
                if (checked) {
                    // console.info("smoke testing if checked gate11 allGatess11", allGatess11);
                    updatedFilter.gateFilters = allGatess11;
                    // console.info("smoke testing if checked gate11 allGatess11 2", updatedFilter.gateFilters);
                } else {
                    updatedFilter.gateFilters = [];
                }
                setFlightFilters(updatedFilter);
                return;

            case GATE11_FILTER_TYPES.ONE:
                let gateNumber = e.target.value;
                if (checked) {
                    // console.info("smoke testing if checked gate11");
                    updatedFilter.gateFilters = updatedFilter.gateFilters.concat(gateNumber);
                    // console.info("401 updatedFilter", updatedFilter);
                    // console.info("401 gate filters", updatedFilter.gateFilters);
                } else {
                    updatedFilter.gateFilters = updatedFilter.gateFilters.filter((gate) => gate !== gateNumber);
                }
                setFlightFilters(updatedFilter);
                return;
            default:
                return;
        }
    };

    const onSetHour = (e, newValue) => {
        let updatedFilter = { ...flightFilters, hourFilter: newValue };
        setFlightFilters(updatedFilter);
        return;
    };

    const applyFilters = () => {
        LocalStorageHelper.appliedFilters.set(flightFilters);
        onFlightFilter(flightFilters);
        handleClose();
    };

    return (
        <div>
            <FormControl component="fieldset" required error={error}>
                <FormLabel>Select Fleet</FormLabel>
                <FormGroup>
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={
                                            allModels.length != 0 &&
                                            flightFilters.aircraftFilters.length === allModels.length
                                        }
                                        onChange={(e) => {
                                            onSetFleet(FLEET_FILTER_TYPES.ALL, e);
                                        }}
                                        value="allGates"
                                    />
                                }
                                label="Select all fleet type"
                            />
                        </Grid>
                    </Grid>

                    <div className="clear"></div>
                    <Grid container spacing={1}>
                        {allModels.map((gate) => (
                            <Grid id={gate} item xs={4}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={flightFilters.aircraftFilters?.includes(gate)}
                                            onChange={(e) => {
                                                onSetFleet(FLEET_FILTER_TYPES.ONE, e);
                                            }}
                                            value={gate}
                                        />
                                    }
                                    label={fleetLabel(gate)}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </FormGroup>

                <FormLabel>Select Gate Number</FormLabel>
                <FormGroup>
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={flightFilters.gateFilters?.length === allGatess11?.length}
                                        onChange={(e) => {
                                            onSetGate11(GATE11_FILTER_TYPES.ALL, e);
                                        }}
                                        value="allGates"
                                    />
                                }
                                label="Select all gates numbers"
                            />
                        </Grid>
                    </Grid>

                    <div className="clear"></div>
                    <Grid container spacing={1}>
                        {allGatess11?.map((gate) => (
                            <Grid id={gate} item xs={4}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={flightFilters.gateFilters?.includes(gate)}
                                            onChange={(e) => {
                                                onSetGate11(GATE11_FILTER_TYPES.ONE, e);
                                            }}
                                            value={gate}
                                        />
                                    }
                                    label={gate11Label(gate)}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </FormGroup>

                <FormLabel>Select Time Window</FormLabel>
                <Slider
                    value={flightFilters.hourFilter}
                    min={1}
                    max={maxHour}
                    aria-labelledby="range-slider"
                    getAriaValueText={valuetext}
                    marks={marks()}
                    onChange={onSetHour}
                />
                <br />
            </FormControl>
            <Button onClick={applyFilters}>Apply</Button>
        </div>
    );
};

export default StationFilter;
